import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Dropdown({ label, children, isActive }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  return (
    <li className={`nav-dropdown${open ? ' open' : ''}`} ref={ref}>
      <button
        className={`nav-drop-btn${isActive ? ' active' : ''}`}
        onClick={() => setOpen(!open)}
      >
        {label} <span className="drop-arrow">&#9662;</span>
      </button>
      <ul className="drop-menu" onClick={() => setOpen(false)}>
        {children}
      </ul>
    </li>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const kjvActive = isActive('/bible') || isActive('/search') || isActive('/why-kjv') || isActive('/side-by-side') || isActive('/free-bible');
  const americaActive = isActive('/state-mottos') || isActive('/patriotic') || isActive('/conservative') || isActive('/liberal') || isActive('/apolitical') || isActive('/american');

  return (
    <nav className={scrolled ? 'scrolled' : ''}>
      <Link to="/" className="nav-brand">KJV<span>USA</span>.org</Link>
      <ul className={`nav-links${open ? ' open' : ''}`}>
        <li><Link to="/" className={isActive('/') ? 'active' : ''}>Home</Link></li>
        <Dropdown label="Resources for the KJV" isActive={kjvActive}>
          <li><Link to="/bible">Read the Bible</Link></li>
          <li><Link to="/search">Search KJV</Link></li>
          <li><Link to="/why-kjv">Why the KJV</Link></li>
          <li><Link to="/side-by-side">KJV vs. Modern Side by Side</Link></li>
          <li><Link to="/free-bible">Get a Free Bible</Link></li>
        </Dropdown>
        <Dropdown label="Resources for America" isActive={americaActive}>
          <li><Link to="/state-mottos">State Mottos</Link></li>
          <li><Link to="/patriotic">The Most Patriotic Thing You Can Do</Link></li>
          <li><Link to="/conservative">Why Being Conservative Won't Save You</Link></li>
          <li><Link to="/liberal">Why Being Liberal Won't Save You</Link></li>
          <li><Link to="/apolitical">Why Being Apolitical Won't Save You</Link></li>
          <li><Link to="/american">Why Being American Won't Save You</Link></li>
        </Dropdown>
        <li><Link to="/about" className={isActive('/about') ? 'active' : ''}>About</Link></li>
        <li><Link to="/faq" className={isActive('/faq') ? 'active' : ''}>FAQ</Link></li>
        <li><Link to="/salvation" className={isActive('/salvation') ? 'active' : ''}>How to Be Saved</Link></li>
      </ul>
      <button className="hamburger" onClick={() => setOpen(!open)} aria-label="Menu">
        <span /><span /><span />
      </button>
    </nav>
  );
}
